import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { TaggableNamed } from '../base/taggable-named';

@Metamodel.model({
    name: ModelConstants.sqlDatabase,
    display: [shellStringResources.SynapseSQLDatabases],
    reusable: true,
    referable: true,
    transient: true // Make it transient as we don't need it persist via Shell for now
})
export class SqlDatabase extends TaggableNamed {
    @Metamodel.attribute({
    })
    public rawTags: { [key: string]: string };

    @Metamodel.attribute({
    })
    public location: string;

    @Metamodel.attribute({
    })
    public collation?: string;

    @Metamodel.attribute({
    })
    public creationDate?: string;

    @Metamodel.attribute({
    })
    public maxSizeBytes?: number;

    @Metamodel.attribute({
    })
    public databaseGuid?: string;

    // represent status property of SDK model
    // but status is already part of Named
    // so sqlDatabaseStatus
    @Metamodel.attribute({
    })
    public sqlDatabaseStatus?: string;

    @Metamodel.attribute({
    })
    public createMode?: string;
}
